// Import images
import WebImage1 from '../images/web-project-1.jpg';
import WebImage2 from '../images/web-project-2.jpg';
import MobileImage1 from '../images/mobile-project-1.jpg';
import MobileImage2 from '../images/mobile-project-2.jpg';
import UIImage1 from '../images/ui-project-1.jpg';
import UIImage2 from '../images/ui-project-2.jpg';
import Exact from '../images/Screenshot From 2025-03-01 17-35-15.png';

export const projectsData = [
  {
    id: 1,
    title: 'Exact Connect',
    category: 'Web Application',
    img: WebImage2,
    ProjectHeader: {
      title: 'Exact Connect',
      publishDate: 'Oct 26, 2024',
      tags: 'Web Application',
    },
    ProjectInfo: {
      ClientHeading: 'About Project',
      CompanyInfo: [
        {
          id: 1,
          title: 'Name',
          details: 'Exact Connect',
        },
        {
          id: 2,
          title: 'Services',
          details: 'UI Design , Frontend Development & Backend Development',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://exactconnect.online',
        },
      ],

      Technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'React.js',
            'TailwindCSS',
            'Figma',
            'Java(spring boot)',
            'Payment gateways(Mpesa,Litecoin)',
            'PostgreSQL',
            'Vercel',
          ],
        },
      ],
      ProjectDetailsHeading: 'Challenge',
      ProjectDetails: [
        {
          id: 1,
          details:
            'The client needed a robust web application to manage user subscriptions and process payments seamlessly. The challenge was to integrate multiple payment gateways while ensuring a smooth user experience.',
        },
        {
          id: 2,
          details:
            'We developed a responsive UI using React.js and TailwindCSS, ensuring the application was accessible on all devices.',
        },
        {
          id: 3,
          details:
            'The backend was built using Java (Spring Boot) to handle complex business logic and ensure scalability.',
        },
        {
          id: 4,
          details:
            'PostgreSQL was used as the database to manage user data and subscription details efficiently.',
        },
      ],
    },
  },
  {
    id: 2,
    title: 'School Management System',
    category: 'Web Application',
    img: MobileImage2,
    ProjectHeader: {
      title: 'School Management System',
      publishDate: 'Aug 2, 2024',
      tags: 'Web Application',
    },
    ProjectInfo: {
      ClientHeading: 'About Client',
      CompanyInfo: [
        {
          id: 1,
          title: 'Name',
          details: 'Schools',
        },
        {
          id: 2,
          title: 'Services',
          details: 'UI Design , Frontend Development & Backend Development',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://sms-frontend-woad.vercel.app/',
        },
      ],

      Technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'React.js',
            'TailwindCSS',
            'Figma',
            'Python(Flask',
            'Payment gateways(Mpesa)',
            'Supabase',
            'Vercel',
            'Render',
          ],
        },
      ],
      ProjectDetailsHeading: 'Challenge',
      ProjectDetails: [
        {
          id: 1,
          details:
            'The school management system was developed to address the inefficiencies and challenges faced by educational institutions in managing their daily operations. Traditional methods of managing student records, attendance, grades, and communication between teachers, students, and parents are often time-consuming, error-prone, and fragmented',
        },
        {
          id: 2,
          details:
            'We developed a responsive UI using React.js and TailwindCSS, ensuring the application was accessible on all devices.',
        },
        {
          id: 3,
          details:
            'The backend was built using Java (Spring Boot) to handle complex business logic and ensure scalability.',
        },
        {
          id: 4,
          details:
            'PostgreSQL was used as the database to manage user data and subscription details efficiently.',
        },
      ],
    },
  },
  {
    id: 3,
    title: 'Teeflex Gym',
    category: 'UI/UX Design',
    img: UIImage1,
    ProjectHeader: {
      title: 'TEEFLEX GYM AND FITNESS CENTER',
      publishDate: 'Feb 26, 2024',
      tags: 'UI / Frontend',
    },
    ProjectInfo: {
      ClientHeading: 'About Client',
      CompanyInfo: [
        {
          id: 1,
          title: 'Name',
          details: 'Teeflex Fitness Center',
        },
        {
          id: 2,
          title: 'Services',
          details: 'UI Design , Frontend Development & Backend Development',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://www.teeflexfitness.com/',
        },
      ],

      Technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'React.js',
            'TailwindCSS',
            'Figma',
            'Python(Flask',
            'Payment gateways(Mpesa)',
            'Supabase',
            'True Host',
            'Render',
          ],
        },
      ],
      ProjectDetailsHeading: 'Challenge',
      ProjectDetails: [
        {
          id: 1,
          details:
            'I created Teeflex Gym Center to streamline operations for gym owners and enhance the experience for members. The project was inspired by the need to automate client reminders, track subscriptions, and manage gym activities efficiently.',
        },
        {
          id: 2,
          details:
            'We developed a responsive UI using React.js and TailwindCSS, ensuring the application was accessible on all devices.',
        },
        {
          id: 3,
          details:
            'The backend was built using Java (Spring Boot) to handle complex business logic and ensure scalability.',
        },
        {
          id: 4,
          details:
            'PostgreSQL was used as the database to manage user data and subscription details efficiently.',
        },
      ],
    },
  },
  {
    id: 4,
    title: 'Haki App',
    category: 'Web Application',
    img: UIImage2,
    ProjectHeader: {
      title: 'Haki Application',
      publishDate: 'Oct 5, 2024',
      tags: 'UI / Frontend/Web App',
    },
    ProjectInfo: {
      ClientHeading: 'About Project',
      CompanyInfo: [
        {
          id: 1,
          title: 'Name',
          details: 'Haki App',
        },
        {
          id: 2,
          title: 'Services',
          details: 'UI Design , Frontend Development & Backend Development',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://haki-ruddy.vercel.app/',
        },
      ],

      Technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'React.js',
            'TailwindCSS',
            'Figma',
            'Python(Flask)',
            'Payment gateways(Mpesa)',
            'Supabase',
            'Vercel',
            'Render',
          ],
        },
      ],
      ProjectDetailsHeading: 'Challenge',
      ProjectDetails: [
        {
          id: 1,
          details:
            'We created the Haki App to empower citizens by democratizing access to legal knowledge and resources.Our motivation was stemmed from the protest kenyans watched during the Gen-z peacuful protest where we saw opportunity to leverage technology to create a scalable and impactful solution  that could reach a wide audience, especially in regions with limited access to legal aid.',
        },
        {
          id: 2,
          details:
            'We developed a responsive UI using React.js and TailwindCSS, ensuring the application was accessible on all devices.',
        },
        {
          id: 3,
          details:
            'The backend was built using Java (Spring Boot) to handle complex business logic and ensure scalability.',
        },
        {
          id: 4,
          details:
            'PostgreSQL was used as the database to manage user data and subscription details efficiently.',
        },
      ],
    },
  },
  {
    id: 5,
    title: 'Biegon Dev',
    category: 'Web Application',
    img: MobileImage1,
    ProjectHeader: {
      title: 'Personal Portfolio',
      publishDate: 'Jan 2, 2025',
      tags: 'UI / Frontend',
    },
    ProjectInfo: {
      ClientHeading: 'About Project',
      CompanyInfo: [
        {
          id: 1,
          title: 'Name',
          details: 'Biegon Dev',
        },
        {
          id: 2,
          title: 'Services',
          details: 'UI Design , Frontend Development ',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://www.biegon.dev/',
        },
      ],

      Technologies: [
        {
          title: 'Tools & Technologies',
          techs: ['React.js', 'TailwindCSS', 'Figma', 'Cloudfare', 'Vercel'],
        },
      ],
      ProjectDetailsHeading: 'Challenge',
      ProjectDetails: [
        {
          id: 1,
          details:
            'The client needed a robust web application to manage user subscriptions and process payments seamlessly. The challenge was to integrate multiple payment gateways while ensuring a smooth user experience.',
        },
        {
          id: 2,
          details:
            'We developed a responsive UI using React.js and TailwindCSS, ensuring the application was accessible on all devices.',
        },
        {
          id: 3,
          details:
            'The backend was built using Java (Spring Boot) to handle complex business logic and ensure scalability.',
        },
        {
          id: 4,
          details:
            'PostgreSQL was used as the database to manage user data and subscription details efficiently.',
        },
      ],
    },
  },
  {
    id: 6,
    title: 'Darasa Hub',
    category: 'UI/UX Design',
    img: WebImage1,
    ProjectHeader: {
      title: 'Project Management UI - From Context',
      publishDate: 'Feb 26, 2024',
      tags: 'UI / Frontend',
    },
    ProjectInfo: {
      ClientHeading: 'About Client',
      CompanyInfo: [
        {
          id: 1,
          title: 'Name',
          details: 'Exact Connect',
        },
        {
          id: 2,
          title: 'Services',
          details: 'UI Design , Frontend Development & Backend Development',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://exactconnect.online',
        },
      ],

      Technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'React.js',
            'TailwindCSS',
            'Figma',
            'Java(spring boot)',
            'Payment gateways(Mpesa,Litecoin)',
            'PostgreSQL',
            'Vercel',
          ],
        },
      ],
      ProjectDetailsHeading: 'Challenge',
      ProjectDetails: [
        {
          id: 1,
          details:
            'The client needed a robust web application to manage user subscriptions and process payments seamlessly. The challenge was to integrate multiple payment gateways while ensuring a smooth user experience.',
        },
        {
          id: 2,
          details:
            'We developed a responsive UI using React.js and TailwindCSS, ensuring the application was accessible on all devices.',
        },
        {
          id: 3,
          details:
            'The backend was built using Java (Spring Boot) to handle complex business logic and ensure scalability.',
        },
        {
          id: 4,
          details:
            'PostgreSQL was used as the database to manage user data and subscription details efficiently.',
        },
      ],
    },
  },
  {
    id: 7,
    title: 'Urban Tyger Ecommerce Design',
    category: 'UI/UX Design',
    img: WebImage1,
    ProjectHeader: {
      title: 'Project Management UI - From Context',
      publishDate: 'Feb 26, 2024',
      tags: 'UI / Frontend',
    },
    ProjectInfo: {
      ClientHeading: 'About Client',
      CompanyInfo: [
        {
          id: 1,
          title: 'Name',
          details: 'Exact Connect',
        },
        {
          id: 2,
          title: 'Services',
          details: 'UI Design , Frontend Development & Backend Development',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://exactconnect.online',
        },
      ],

      Technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'React.js',
            'TailwindCSS',
            'Figma',
            'Java(spring boot)',
            'Payment gateways(Mpesa,Litecoin)',
            'PostgreSQL',
            'Vercel',
          ],
        },
      ],
      ProjectDetailsHeading: 'Challenge',
      ProjectDetails: [
        {
          id: 1,
          details:
            'The client needed a robust web application to manage user subscriptions and process payments seamlessly. The challenge was to integrate multiple payment gateways while ensuring a smooth user experience.',
        },
        {
          id: 2,
          details:
            'We developed a responsive UI using React.js and TailwindCSS, ensuring the application was accessible on all devices.',
        },
        {
          id: 3,
          details:
            'The backend was built using Java (Spring Boot) to handle complex business logic and ensure scalability.',
        },
        {
          id: 4,
          details:
            'PostgreSQL was used as the database to manage user data and subscription details efficiently.',
        },
      ],
    },
  },
  {
    id: 8,
    title: 'Waki App designs',
    category: 'Web Application',
    img: WebImage1,
    ProjectHeader: {
      title: 'Project Management UI - From Context',
      publishDate: 'Feb 26, 2024',
      tags: 'UI / Frontend',
    },
    ProjectInfo: {
      ClientHeading: 'About Client',
      CompanyInfo: [
        {
          id: 1,
          title: 'Name',
          details: 'Exact Connect',
        },
        {
          id: 2,
          title: 'Services',
          details: 'UI Design , Frontend Development & Backend Development',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://exactconnect.online',
        },
      ],

      Technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'React.js',
            'TailwindCSS',
            'Figma',
            'Java(spring boot)',
            'Payment gateways(Mpesa,Litecoin)',
            'PostgreSQL',
            'Vercel',
          ],
        },
      ],
      ProjectDetailsHeading: 'Challenge',
      ProjectDetails: [
        {
          id: 1,
          details:
            'The client needed a robust web application to manage user subscriptions and process payments seamlessly. The challenge was to integrate multiple payment gateways while ensuring a smooth user experience.',
        },
        {
          id: 2,
          details:
            'We developed a responsive UI using React.js and TailwindCSS, ensuring the application was accessible on all devices.',
        },
        {
          id: 3,
          details:
            'The backend was built using Java (Spring Boot) to handle complex business logic and ensure scalability.',
        },
        {
          id: 4,
          details:
            'PostgreSQL was used as the database to manage user data and subscription details efficiently.',
        },
      ],
    },
  },
  {
    id: 9,
    title: 'Car Management Sytem',
    category: 'Web Application',
    img: WebImage1,
    ProjectHeader: {
      title: 'Project Management UI - From Context',
      publishDate: 'Feb 26, 2024',
      tags: 'UI / Frontend',
    },
    ProjectInfo: {
      ClientHeading: 'About Client',
      CompanyInfo: [
        {
          id: 1,
          title: 'Name',
          details: 'Exact Connect',
        },
        {
          id: 2,
          title: 'Services',
          details: 'UI Design , Frontend Development & Backend Development',
        },
        {
          id: 3,
          title: 'Website',
          details: 'https://exactconnect.online',
        },
      ],

      Technologies: [
        {
          title: 'Tools & Technologies',
          techs: [
            'React.js',
            'TailwindCSS',
            'Figma',
            'Java(spring boot)',
            'Payment gateways(Mpesa,Litecoin)',
            'PostgreSQL',
            'Vercel',
          ],
        },
      ],
      ProjectDetailsHeading: 'Challenge',
      ProjectDetails: [
        {
          id: 1,
          details:
            'The client needed a robust web application to manage user subscriptions and process payments seamlessly. The challenge was to integrate multiple payment gateways while ensuring a smooth user experience.',
        },
        {
          id: 2,
          details:
            'We developed a responsive UI using React.js and TailwindCSS, ensuring the application was accessible on all devices.',
        },
        {
          id: 3,
          details:
            'The backend was built using Java (Spring Boot) to handle complex business logic and ensure scalability.',
        },
        {
          id: 4,
          details:
            'PostgreSQL was used as the database to manage user data and subscription details efficiently.',
        },
      ],
    },
  },
];
